import {mock} from './index';

export default {
  getAssetList: () => mock('/admin/asset/list'),
  getStruList: () => mock('/admin/structure/list'),
  getAssStruList: () => mock('/admin/asset/structure/list'),
  syncAssetTree: () => mock('/admin/asset/sync')
};
